(() => {
  const initHeader = () => {
    const button = document.querySelector('[data-ac-menu-button]');
    const nav = document.querySelector('[data-ac-nav]');
    if (!button || !nav || button.dataset.ready === 'true') return;

    button.dataset.ready = 'true';
    const close = () => {
      button.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.body.classList.remove('ac-menu-open');
    };

    button.addEventListener('click', () => {
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(willOpen));
      nav.classList.toggle('is-open', willOpen);
      document.body.classList.toggle('ac-menu-open', willOpen);
    });

    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    window.addEventListener('resize', () => {
      if (window.innerWidth > 990) close();
    });
  };

  const initGallery = () => {
    const image = document.querySelector('[data-ac-gallery-main]');
    const buttons = document.querySelectorAll('[data-ac-gallery-thumb]');
    if (!image || !buttons.length || image.dataset.ready === 'true') return;
    image.dataset.ready = 'true';
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        image.src = button.dataset.src;
        image.alt = button.dataset.alt || '';
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });
  };

  const init = () => {
    initHeader();
    initGallery();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
